export default {"src":"/_next/static/media/nuki-logo.3abf3901.svg","height":63,"width":100,"blurWidth":0,"blurHeight":0};